/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Medical_Technology24Inputs */

const en__field__enum_primarystudyinterest_study_medical_technology24 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Medical_Technology24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medical Technology`)
};

const de__field__enum_primarystudyinterest_study_medical_technology24 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Medical_Technology24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medizintechnik`)
};

/**
* | output |
* | --- |
* | "Medical Technology" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Medical_Technology24Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_medical_technology24 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Medical_Technology24Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Medical_Technology24Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_medical_technology24(inputs)
	return de__field__enum_primarystudyinterest_study_medical_technology24(inputs)
});
export { _field__enum_primarystudyinterest_study_medical_technology24 as "_field__enum_primaryStudyInterest_STUDY_MEDICAL_TECHNOLOGY" }